import {
  ArrowLeft,
  CheckCircle2,
  GitBranch,
  LoaderCircle,
  LockKeyhole,
  ShieldCheck,
} from 'lucide-react'
import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { resetPassword } from '../api.js'
import { useLanguage } from '../contexts/LanguageContext.jsx'
import { NOINDEX_ROBOTS, setPageMetadata } from '../page-metadata.js'

function ResetPasswordPage() {
  const { t } = useLanguage()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') || ''
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [complete, setComplete] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => setPageMetadata({
    title: '重置密码 - 青途 AI',
    description: '青途 AI 账号密码重置。',
    robots: NOINDEX_ROBOTS,
  }), [])

  const submit = async (event) => {
    event.preventDefault()
    setError('')
    if (!token) {
      setError('重置链接缺少 token，请重新打开邮件中的链接。')
      return
    }
    if (password.length < 8) {
      setError('密码长度至少为 8 位')
      return
    }
    if (password !== confirmPassword) {
      setError('两次输入的密码不一致')
      return
    }

    setSubmitting(true)
    try {
      await resetPassword(token, password)
      setComplete(true)
    } catch (requestError) {
      setError(requestError.message)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <main className="auth-action-screen">
      <section className="auth-action-panel">
        <Link to="/" className="auth-brand auth-action-brand">
          <span className="brand-icon"><GitBranch size={22} /></span>
          <span>
            <strong>{t('nav.brand')}</strong>
            <small>{t('nav.brandSub')}</small>
          </span>
        </Link>
        {complete ? (
          <>
            <span className="auth-action-icon"><CheckCircle2 size={30} /></span>
            <span className="eyebrow">PASSWORD UPDATED</span>
            <h1>密码重置成功</h1>
            <p>新密码已经生效，原重置链接不能再次使用。</p>
            <Link className="primary-button auth-action-button" to="/login">使用新密码登录</Link>
          </>
        ) : (
          <>
            <span className="auth-action-icon"><ShieldCheck size={28} /></span>
            <span className="eyebrow">ACCOUNT SECURITY</span>
            <h1>设置新密码</h1>
            <p>请设置 8-72 位的新密码。提交成功后，此链接会立即失效。</p>
            <form className="auth-form" onSubmit={submit}>
              <label htmlFor="reset-password">新密码</label>
              <div className="input-wrap">
                <LockKeyhole size={18} />
                <input
                  id="reset-password"
                  type="password"
                  value={password}
                  placeholder="输入新密码"
                  onChange={(event) => setPassword(event.target.value)}
                  autoComplete="new-password"
                  required
                  minLength={8}
                  maxLength={72}
                />
              </div>
              <label htmlFor="reset-password-confirm">确认新密码</label>
              <div className="input-wrap">
                <LockKeyhole size={18} />
                <input
                  id="reset-password-confirm"
                  type="password"
                  value={confirmPassword}
                  placeholder="再次输入新密码"
                  onChange={(event) => setConfirmPassword(event.target.value)}
                  autoComplete="new-password"
                  required
                  minLength={8}
                  maxLength={72}
                />
              </div>
              {error && <p className="form-error" role="alert">{error}</p>}
              <button
                className="primary-button auth-action-button"
                type="submit"
                disabled={submitting}
              >
                {submitting && <LoaderCircle className="spin" size={17} />}
                {submitting ? '处理中...' : '重置密码'}
              </button>
            </form>
            <Link className="auth-action-home" to="/login">
              <ArrowLeft size={15} /> 返回登录
            </Link>
          </>
        )}
      </section>
    </main>
  )
}

export default ResetPasswordPage
